import React, {useState, useEffect} from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import AddAppointmentLayer from "../components/AddAppointmentLayer";

import Select from "react-select";
import { useParams } from "react-router-dom";
import { API_URL } from "..";
const optionsForServices = [
  {
    label: "Electrical Installation Condition Report",
    value: "Electrical Installation Condition Report",
  },
  {
    label: "Rwiring House",
    value: "Rwiring House",
  },
  {
    label: "PAT Testing",
    value: "PAT Testing",
  },
  {
    label: "Electrical Fuse Box Installation",
    value: "Electrical Fuse Box Installation",
  },
  {
    label: "Electrical Fault",
    value: "Electrical Fault",
  },
  {
    label: "Electrical Sockets & Switches Installation",
    value: "Electrical Sockets & Switches Installation",
  },
  {
    label: "Electrical Light Fitting",
    value: "Electrical Light Fitting",
  },
  {
    label: "Electrical Outdoor Light Installation",
    value: "Electrical Outdoor Light Installation",
  },
  {
    label: "Electrical Car Charger",
    value: "Electrical Car Charger",
  },
  {
    label: "Electrical Inspection",
    value: "Electrical Inspection",
  }
]
const EditAppointmentPage = () => {
    const {id} = useParams();
    const [electricianList, setElectricianList] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);
    const [electricianListSelect, setElectricianListSelect] = useState({});
    const [data,setData]= useState({})
  
    const fetchElectrician = async () => {
      let headerList = {
        Accept: "*/*",
        "Content-type": "application/json",
      };
      const response = await fetch(
        API_URL+"/api/user/fetch-electrician",
        { method: "GET", headers: headerList }
      );
      const data = await response.json();
      if (response.status === 200) {
        let mapedData = data.data.map((e) => ({
          label: e.name,
          value: e.id,
        }));
        setElectricianList(mapedData);
      }
    };
    useEffect(() => {
      fetchElectrician()
      fetchAppointments()
    }, [1]);
   
    const fetchAppointments = async () => {
        let headerList = {
          Accept: "*/*",
          "Content-type": "application/json",
        };
        const response = await fetch(
          API_URL+`/api/job/fetch-single/${id}`,
          { method: "GET", headers: headerList }
        );
        const dataFor = await response.json();
        if (response.status === 200) {
            setData(dataFor.job)
            console.log(dataFor.job)
            if(dataFor.job.service_required){
                
                const values = dataFor.job.service_required.split(',');
                let mapedData = values.map((e) => ({
                    label: e,
                    value: e,
                  }));
                setSelectedServices(mapedData)

            }
            if(dataFor.job.assignedTo){
              setElectricianListSelect({
                      label: dataFor.job.assignedTo.name,
                      value: dataFor.job.assignedTo.id
              })

            }
            
        }
      };

    const onFormSubmission = async (event) => {
      event.preventDefault();
      const user = JSON.parse(localStorage.getItem('user'));
      let headerList = {
        Accept: "*/*",
        "Content-type": "application/json",
      };
      const selectedServiceRequired = selectedServices.map((e)=>e.value)
      const bodyContent = JSON.stringify({
        "client_name": event.target.elements.client_name.value,
        "email": event.target.elements.email.value,
        "phone": event.target.elements.phone.value,
        "address": event.target.elements.address.value,
        "job_cost": event.target.elements.job_cost.value,
        "postcode": event.target.elements.postcode.value,
        "service_required":selectedServiceRequired.toString(),
        "assigned_to" :electricianListSelect?.value,
        "assigned_by": user.id,
        "description" : event.target.elements.description.value
  
      });
      const response = await fetch(`${API_URL}/api/job/update-single/${id}`,{method:'PUT', headers:headerList, body: bodyContent});
      const data = await response.json();
      if(response.status === 201){
          console.log(data.job)
      }else{
          alert('Invalid Information')
      }
    };
    const handleChangeElectrician = (selected) => {
      setElectricianListSelect(selected || {});
    };
    const handleChangeService = (selectedOptions) => {
      // Set the state to an array of selected values
      setSelectedServices(
        selectedOptions ? selectedOptions.map((option) => option) : []
      );
    }
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Job" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
      <div className="card-body p-24">
        <div className="row justify-content-center">
          <div className="col-xxl-6 col-xl-8 col-lg-10">
            <div className="card border">
              <div className="card-body">
                {/* Upload Image End */}
                <form onSubmit={onFormSubmission}>
                  <div className="mb-20">
                    <label
                      htmlFor="name"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Client Name <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="name"
                      name="client_name"
                      value={data.client_name}
                      onChange={(e)=>setData((prev)=>({...prev,client_name:e.target.value}))}
                      placeholder="Enter Full Name"
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="email"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Email <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="email"
                      value={data.email}
                      onChange={(e)=>setData((prev)=>({...prev,email:e.target.value}))}
                      className="form-control radius-8"
                      id="email"
                      name="email"
                      placeholder="Enter email address"
                    />
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="number"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Phone
                    </label>
                    <input
                      type="tel"
                      value={data.phone}
                      onChange={(e)=>setData((prev)=>({...prev,phone:e.target.value}))}
                      className="form-control radius-8"
                      id="number"
                      name="phone"
                      placeholder="Enter phone number"
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="number"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Job Cost
                    </label>
                    <input
                      type="number"
                      min={0}
                      value={data.job_cost}
                      onChange={(e)=>setData((prev)=>({...prev,job_cost:e.target.value}))}
                      className="form-control radius-8"
                      id="number"
                      name="job_cost"
                      placeholder="0.00"
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="number"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="number"
                      name="address"
                      value={data.address}
                      onChange={(e)=>setData((prev)=>({...prev,address:e.target.value}))}
                      placeholder="Enter phone number"
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="number"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      PostCode
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="number"
                      name="postcode"
                      value={data.postcode}
                      onChange={(e)=>setData((prev)=>({...prev,postcode:e.target.value}))}
                      placeholder="Enter phone number"
                    />
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="service"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Select Service that required
                    </label>
                    <Select
                      id="service"
                      options={optionsForServices}
                      isMulti
                      value={selectedServices}
                      onChange={handleChangeService}
                    />
                  </div>
                  <div className="mb-20">
                    <p>

                      {selectedServices.map((e,index) => {
                        return <span key={index}>{e.value+','}</span>;
                      })}
                    </p>
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="select"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Select Service Electrician
                    </label>
                    <Select
                      id="select"
                      value={electricianListSelect}
                      options={electricianList}
                      onChange={handleChangeElectrician}
                    />
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="desc"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Description
                    </label>
                    <textarea
                      name="description"
                      className="form-control radius-8"
                      id="desc"
                      value={data.message}
                      onChange={(e)=>setData((prev)=>({...prev, message:e.target.value}))}
                      placeholder="Write description..."
                      defaultValue={""}
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


      </MasterLayout>
    </>
  );
};

export default EditAppointmentPage;
